module.exports = __webpack_public_path__ + "img/Group 7691 (3).9c6108f4.jpg";